<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Select from "@/components/c-select";
import Loading from "@/components/c-loading";
import { customerService } from "../../../services/contactservice/customer.service";
import { customerpartnerService } from "../../../services/contactservice/customerpartner.service";
import { customerattachmentService } from "../../../services/contactservice/customerattachment.service";
import i18n from "../../../i18n";
/* eslint-disable no-console */

/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Customer Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Select, 

  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Customer",
      customerData: null,
      idTypeList: {},
      genderList: {},
      nationalityList: {},
      typeList: {},
      
      breadCrumb: {},
      attachement: {},
      dataCode: '',
      dataType: 0,
      dataName: '',
      dataNameEn: '',
      dataPhone1: '',
      dataPhone2: '',
      dataEmail: '',
      dataNationality: 0,
      dataGender: 0,
      dataDOB: '',
      dataIDType: 0,
      dataIDNo: '',
      dataIDDate: '',
      dataAddress: '',
      dataAddressEn: '',
      dataPhoto: [],
      dataDoc: [],
      dataPartners: []
      
    };
  },
  mounted() {
    
    // this.loadingIDTypeData();
    // this.loadingGenderData();
    // this.loadingCustomerTypeData();
    // this.loadingNationalityData();

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else {
      this.loadingData(0);   
    } 
  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      customerService.getOne(id)
        .then(response => {

          this.fetchingStats = true;

          if(response.data) {
            this.breadCrumb = {
              text: response.data.name + " - (" + response.data.code + ")",
              active: true,
            };
            this.customerData = response;

            this.dataCode = this.customerData.data.code;
            this.dataType = this.customerData.data.type_id;
            this.dataName = this.customerData.data.name;
            this.dataNameEn = this.customerData.data.name_en;
            this.dataPhone1 = this.customerData.data.phone_no_1;
            this.dataPhone2 = this.customerData.data.phone_no_2;
            this.dataEmail = this.customerData.data.email;
            this.dataNationality = this.customerData.data.nationality_id;
            this.dataGender = this.customerData.data.sex;
            this.dataDOB = this.customerData.data.dob;
            this.dataIDType = this.customerData.data.id_type;
            this.dataIDNo = this.customerData.data.id_no;
            this.dataIDDate = this.customerData.data.id_date;
            this.dataAddress = this.customerData.data.address;
            this.dataAddressEn = this.customerData.data.address_en;
            this.dataPhoto.push(this.customerData.data.photo);

            this.customerData.data.collections.map(item => {
              if('customer_attachments' in item) {
                this.dataDoc = item.customer_attachments.filter(attachment => attachment.path != null);
              } else if('customer_partners' in item) {
                this.dataPartners = item.customer_partners;
              }
            });

            this.loadingCustomerAttachmentByCustomerId(this.customerData.data.id);
          }
          
          this.loadingSettings(response.setting);
        });
    },

    loadingCustomerAttachmentByCustomerId: function(customerId) {

      let param = customerId == 0 ? '?page=0' : `?page=0&clause={"clause":[{"conjuction":"and","customer_attachments.customer_id":{"value":${customerId}}}]}`;

      customerattachmentService.getList(param)
        .then(response => {
          this.attachement = response;
        });
    },

    // loadingIDTypeData: function() {

    //   servicehelpers.getIDTypeData().then(response => {
    //     this.idTypeList = response;
    //   });
    // },

    // loadingGenderData: function() {

    //   servicehelpers.getGenderData().then(response => {
    //     this.genderList = response;
    //   });
    // },

    // loadingNationalityData: function() {

    //   servicehelpers.getNationalityData().then(response => {
    //     this.nationalityList = response;
    //   });
    // },

    // loadingCustomerTypeData: function() {

    //   servicehelpers.getCustomerTypeData().then(response => {
    //     this.typeList = response;
    //   });
    // },

    loadingSettings: function(setting) {

      this.idTypeList = {data: setting.idtypes};
      this.genderList = {data: setting.genders};
      this.nationalityList = {data: setting.nationalities};
      this.typeList  = {data: setting.customertypes};
     
    },

    submitCancel: function() {

      // console.log(this.dataType);

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "customer-list"
          });

        }
      });
      
    },
    submitSave: function() {

      if(!this.dataNationality && this.dataNationality == 0) {
        this.$swal.fire({
          title: i18n.t('general.required.title'),
          text: i18n.t('customer.nationality') + i18n.t('general.required.message'),
          icon: "error",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t('general.success.yes')
        });
        return;
      } 

      this.tryingToSubmit = true;

      let list = [];
      Object.keys(this.$refs).map(el => {
        // console.log(this.$refs[el]);
        if('getPartner' in this.$refs[el][0]) {
          let partner = (this.$refs[el][0]).getPartner();
          if(partner != null) {
            list.push(partner);
          }
          
        }
      });

      let customer = {
        type_id: this.dataType,
        parent_id: 0,
        code: this.dataCode,
        name: this.dataName,
        name_en: this.dataNameEn == '' ? this.dataName : this.dataNameEn,
        sex: this.dataGender,
        dob: this.dataDOB,
        id_date: this.dataIDDate,
        id_type: this.dataIDType,
        id_no: this.dataIDNo,
        nationality_id: this.dataNationality,
        phone_no_1: this.dataPhone1,
        phone_no_2: this.dataPhone2,
        email: this.dataEmail,
        address: this.dataAddress,
        address_en: this.dataAddressEn,
        photo: this.dataPhoto.length == 0 ? '' : this.dataPhoto[0],
        customer_attachments: this.dataDoc,
        customer_partners: list
      };

      // console.log(JSON.stringify(customer));

      if(this.isAdd) {
        customerService.insert(customer)
         .then(response => {
           this.tryingToSubmit = false;
           if(response.status == 200) {
              this.clearForm();
              this.$swal.fire({
                title: i18n.t('general.success.title'),
                text: i18n.t('general.success.message'),
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: i18n.t('general.success.yes'),
                cancelButtonText: i18n.t('general.success.no')
              }).then(result => {
                if (!result.value) {
                  this.$router.push(this.$route.query.redirectFrom || {
                    name: "customer-list"
                  });
                } 
              });
           }
          
        });
      } else {
        // console.log(JSON.stringify(customer));
        customerService.update(this.$route.params.id, customer)
         .then(response => {
          this.tryingToSubmit = false;

          if(response.status == 200) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "customer-list"
            });

            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message-edit'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
      }
    },

    clearForm: function() {
      this.dataCode = '';
      this.dataType = 0;
      this.dataName = '';
      this.dataNameEn = '';
      this.dataPhone1 = '';
      this.dataPhone2 = '';
      this.dataEmail = '';
      this.dataNationality = 0;
      this.dataGender = 0;
      this.dataDOB = '';
      this.dataIDType = 0;
      this.dataIDNo = '';
      this.dataIDDate = '';
      this.dataAddress = '';
      this.dataAddressEn = '';
      this.dataPhoto = [];
      this.dataDoc = [];
      this.dataPartners = [];
      
    }, 

    uploadPhotoSuccess(file, response) {
        // console.log("FFFFF", file);
        this.dataPhoto = [response.data];

        // console.log("#####", this.dataPhoto);
    },
    
    uploadDocSuccess(file, response) {
        // console.log(file);
        // this.dataDoc.push(response.data);

        if(response.data != null) {
          this.dataDoc.push({
            path: response.data
          });
        }
    },

    addPartner() {
      this.dataPartners.push(null);
    },

    removePartner(index, id) {

      this.$swal.fire({
        title: i18n.t('general.confirm.title'),
        text: i18n.t('general.confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          console.log(id);

          if(id == 0) {
            this.dataPartners.splice(index-1, 1);
          } else {

            const index = this.dataPartners.findIndex((item)=> item.id>id);
            this.dataPartners.splice(index, 1);


            customerpartnerService.remove(id)
              .then(response => {

                if(response.status == 200) {
                  console.log(response);
                }
                
              });

          }

        }
      });
      
    }

  }
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('customer.list'),
        href: '/general/customer',
      }, {
        text: $t('customer.new'),
        active: true
      }]" :title="this.isAdd ? $t('customer.new') : $t('customer.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('customer.list'),
        href: '/general/customer',
      }, this.breadCrumb]" :title="this.isAdd ? $t('customer.new') : $t('customer.edit')" />
    </div>

    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'code'"
                    :disabled="true"
                    v-model="dataCode"
                    :label="'customer.code'"
                     /> 
                </div>
                <div class="col-md-6">
                  <Select 
                    :id="'type_id'"
                    :list="this.typeList"
                    v-model="dataType"
                    :label="'customer.type'"
                    :require="true"
                     /> 
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'name'"
                    v-model="dataName"
                    :require="true"
                    :label="'customer.name'"  />
                </div>
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'name-en'"
                    v-model="dataNameEn"
                    :label="'customer.name-en'"  />
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">

                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>
          
          </div>
        </div>
      </div>

      <div class="col-lg-4">
      


      </div>
    </b-form> 
  
  </Layout>
</template>